import React from 'react';
import { Helmet } from 'react-helmet-async';
import { GTM_IFRAME_URL, GTM_SCRIPT, GTM_VALID_PATHS } from '../../constants/gtm';
import { getEnvironment } from '../../utils/env';

const GoogleTagManager = () => {

  if (getEnvironment() !== 'production') return <></>;

  const currentURL = window.location.href;

  const shouldRender = GTM_VALID_PATHS.some(path => currentURL.includes(path));

  if (!shouldRender) return <></>;

  return (
    <>
      <Helmet>
        {/* Google Tag Manager */}
        <script>
          {GTM_SCRIPT}
        </script>
        {/* End Google Tag Manager */}
      </Helmet>

      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe
          src={GTM_IFRAME_URL}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
      {/* End Google Tag Manager (noscript) */}
    </>
  );
};

export default GoogleTagManager;